import { SurveyConfigDisplay } from "../components/Survey/types";

const CONFIG_ORDER = [
  'section',
  'name',
  'lastName',
  'age',
  'gender',
  'cic',
  'curp',
  'phone',
  'email',
  'postalCode',
]

export const isSafe = (data: any[], error: Error | undefined) => {
  if (error || !Array.isArray(data)) {
    return [];
  }

  return data;
};

const reorderArray = (arr: string[], order: string[]): string[] => {
  return order.filter(item => arr.includes(item));
}

const mapStringsForDisplay = (arr: string[]): SurveyConfigDisplay[] => {
  return arr.map((value) => {
    switch (value) {
      case 'section':
        return { value, label: 'Sección electoral', response: '', type: 'section', maxLength: 4 };
      case 'name':
        return { value, label: 'Nombre', response: '', type: 'text' };
      case 'lastName':
        return { value, label: 'Apellido', response: '', type: 'text' };
      case 'age':
        return { value, label: 'Edad', response: '', type: 'number', maxLength: 2 };
      case 'gender':
        return { value, label: 'Género', response: 'Hombre', type: 'combo', options: ['Hombre', 'Mujer', 'Otro'] };
      case 'cic':
        return { value, label: 'Número de credencial', response: '', type: 'number', maxLength: 13 };
      case 'curp':
        return { value, label: 'CURP', response: '', type: 'text', maxLength: 18 };
      case 'phone':
        return { value, label: 'Teléfono', response: '', type: 'number', maxLength: 10 };
      case 'email':
        return { value, label: 'Correo electrónico', response: '', type: 'text' };
      case 'postalCode':
        return { value, label: 'Código postal', response: '', type: 'number', maxLength: 5 };
      default:
        return { value, label: '???', response: '', type: 'text' };
    }
  });
}

export const getSurveyConfig = (obj: { [key: string]: boolean }): SurveyConfigDisplay[] => {
  const properties = Object.entries(obj)
    .filter(([key, value]) => value === true && key !== 'global')
    .map(([key, _]) => key);

  const sorted = reorderArray(properties, CONFIG_ORDER);
  const mapped = mapStringsForDisplay(sorted);
  return mapped;
};

interface GenericGroup<T> {
  [key: string]: T[];
}

export const groupByProperty = <T, K extends keyof T>(items: T[], prop: K): Record<string, T[]> =>
  items.reduce((acc: GenericGroup<T>, item) => {
    const propValue = item[prop];
    const key = propValue !== null && propValue !== undefined ? String(propValue) : 'Unknown';

    return {
      ...acc,
      [key]: [...(acc[key] || []), item],
    };
  }, {});